module.exports = __webpack_public_path__ + "static/bigbrotherboard-3168c7cca5d88b3beee585d24d3d4a06.png";